import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";
import globalStyles from "../../assets/styles/global.module.scss";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface SnackbarProps {
  open: boolean,
  handleClose: () => void,
  message: string,
  type: AlertColor,
  hideDuration: number
}

export default function GlobalSnackbar(props: SnackbarProps) {

  return (

    <Snackbar
      open={props.open}
      autoHideDuration={props.hideDuration}
      onClose={(_event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        props.handleClose();
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      className={globalStyles.globalSnackbar}
    >
      <Alert onClose={props.handleClose} severity={props.type} className={globalStyles.fullwidth}>
        {props.message}
      </Alert>
    </Snackbar>
  );
}
